import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/apiConfig';
import { useParams } from 'react-router-dom';

const CreditNoteInput = () => {
  const { creditNoteId = '', invoiceId } = useParams();
  const decodedId = creditNoteId ? atob(creditNoteId) : creditNoteId;
  const id = decodedId.replace(/\D/g, ''); 
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const [invoice, setInvoices] = useState({});
  const [invoiceItems, setInvoiceItems] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0)

  const route = 'credit_note';

  useEffect(() => {
    if (creditNoteId) {
      setIsEditing(true);
      fetchCreditNoteDetails();
    }

    fetchInvoiceItems();
    fetchInvoiceDetails();
  }, [creditNoteId]);

  const fetchCreditNoteDetails = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.credit_note}${id}/`, { headers });
      const creditNoteDetails = response.data;
      setFormData(creditNoteDetails);
    } catch (error) {
      console.error('Error fetching credit note details:', error);
    }
  };

  const fetchInvoiceDetails = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.invoice}${invoiceId}/`, { headers });
      const invoiceDetails = response.data;
      setInvoices(invoiceDetails);
   
    } catch (error) {
      console.error('Error fetching invoice details:', error);
    }
  };

  const fetchInvoiceItems = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.invoice_item}?invoice=${invoiceId}`, { headers });
      const invoiceItems = response.data;
      setInvoiceItems(invoiceItems)
      // You can add code here to handle the invoice items data
    } catch (error) {
      console.error('Error fetching invoice items:', error);
    }
  };

    const handleItemChange = async (selectedItems) => {
        const amounts = await Promise.all(selectedItems.map(async (item) => {
            try {
              
            const response = await axios.get(`${API_DOMAIN}${API_ROUTES.invoice_item}${item}/`, { headers });
            const invoiceItemDetails = response.data;
            return invoiceItemDetails.total_price.toString();
            } catch (error) {
            console.error('Error fetching invoice item details:', error);
            return 0;
            }
        }));
        //console.log(amounts)
        const totalAmount = amounts.reduce((acc, amount) => acc + parseFloat(amount), 0);
 
        setTotalAmount(totalAmount);
    };


  const creditNoteFields = [
    {
      name: 'invoice',
      type: 'hidden',
      value: invoiceId,
    },
    {
      name: 'invoice_number',
      label: 'Invoice Number',
      type: 'text',
      readOnly: true,
      value: invoice.invoice_number,
    },
   
    {
        name: 'items',
        label: 'Invoice Items',
        type: 'multiselect',
        options: invoiceItems.map(item => ({ value: item.id, label: item.description })),
        onChange: handleItemChange
    },
    {
        name: 'amount',
        label: 'Amount',
        type: 'number',
        readOnly: true,
        value: totalAmount,
        
    },
    {
        name: 'reason',
        label: 'Reason',
        type: 'select',
        options: [
            { value: 'Monthly Overbilling', label: 'Monthly Overbilling' },
            { value: 'Quarterly Overbilling', label: 'Quarterly Overbilling' },
            { value: 'Annual Overbilling', label: 'Annual Overbilling' },
            { value: 'Monthly Cancellation', label: 'Monthly Cancellation' },
            { value: 'Quarterly Cancellation', label: 'Quarterly Cancellation' },
            { value: 'Annual Cancellation', label: 'Annual Cancellation' },
            { value: 'Monthly Discount Error', label: 'Monthly Discount Error' },
            { value: 'Quarterly Discount Error', label: 'Quarterly Discount Error' },
            { value: 'Annual Discount Error', label: 'Annual Discount Error' },
            { value: 'Monthly Duplicate Billing', label: 'Monthly Duplicate Billing' },
            { value: 'Quarterly Duplicate Billing', label: 'Quarterly Duplicate Billing' },
            { value: 'Annual Duplicate Billing', label: 'Annual Duplicate Billing' },
            { value: 'Monthly Partial Service', label: 'Monthly Partial Service' },
            { value: 'Quarterly Partial Service', label: 'Quarterly Partial Service' },
            { value: 'Annual Partial Service', label: 'Annual Partial Service' },
            { value: 'Monthly Refund Request', label: 'Monthly Refund Request' },
            { value: 'Quarterly Refund Request', label: 'Quarterly Refund Request' },
            { value: 'Annual Refund Request', label: 'Annual Refund Request' },
        ]
    },
    {
      name: 'issued_date',
      label: 'Issued Date',
      type: 'date',
    },
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Credit Note' : 'Create Credit Note'}</h1>
      <FormComponent
        fields={creditNoteFields}
        initialFormData={formData}
        route={route}
      />
    </div>
  );
};

export default CreditNoteInput;